module.exports = __webpack_public_path__ + "static/media/incorrect-feedback-icon.2875dd93.svg";